/* eslint-disable react/jsx-closing-bracket-location */
import React, { createContext, useState, ReactNode, ReactElement } from 'react';
import { IMatchesContext, IPrefferencesContext } from '../interfaces/interfaces';
import { trans } from '../helpers/helperFunctions';

export const PrefferencesContext = createContext({} as IPrefferencesContext);
export const MatchesContext = createContext({} as IMatchesContext);

export const PrefferencesProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [language, setLanguage] = useState<string>('');
  const [theme, setTheme] = useState<string>('dark');
  const [parentHost, setParentHost] = useState<string>('');
  const [widgetWidth, setWidgetWidth] = useState<number>(0);

  return (
    <PrefferencesContext.Provider
      value={{
        language,
        setLanguage,
        theme,
        setTheme,
        parentHost,
        setParentHost,
        widgetWidth,
        setWidgetWidth
      }}>
      {children}
    </PrefferencesContext.Provider>
  );
};

export const MatchesProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [selectedDisplayOption, setSelectedDisplayOption] = useState<string>(trans('gamesByDate'));

  const competitionsState = {
    selectedDisplayOption,
    setSelectedDisplayOption
  };

  return (
    <MatchesContext.Provider value={competitionsState}>
      <PrefferencesProvider>{children}</PrefferencesProvider>
    </MatchesContext.Provider>
  );
};
